<template>
  <q-dialog
    id="GeneratorOrderPageSearchItemsModal"
    ref="generatorOrderPageSearchItemsModal"
    noBackdropDismiss
  >
    <q-layout view="Lhh lpR fff" container class="bg-white modal-large">
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>
            {{ $gettext("VIEW_ORDER_INFORMATION") }}
          </q-toolbar-title>
          <q-btn flat @click="hide()">
            <q-icon name="cancel" size="2.5em" />
          </q-btn>
        </q-toolbar>
      </q-header>
      <q-page-container id="content">
        <q-page id="page">
          <generator-order-page-search-items-detail
            v-if="formDetail"
            :forms="formDetail"
          />
          <crud-form
            v-if="formDetail"
            ref="form"
            :form="formDetail[0]"
            :model="formDetail[0].dadosForm"
            :relacionamentos="formDetail[0].relacionamentos"
            class="column"
          >
            <compositions>
              <composition
                slot="controlBatchTicket"
                slot-scope="dados"
                v-bind="dados"
              >
                <template slot="table" slot-scope="dadosTable">
                  <jt-data-table
                    v-bind="dadosTable"
                    rowKey="controlBatchTicket"
                    :row-buttons="false"
                  />
                  <div id="subtitle">
                    <span>
                      {{ $gettext("TOTAL_ORDER") }}: R$ {{ totalOrder }}
                    </span>
                  </div>
                </template>
              </composition>
            </compositions>
          </crud-form>
        </q-page>
      </q-page-container>
      <q-footer class="text-center bg-white q-pb-lg q-pt-sm row justify-center">
        <div>
          <q-btn
            class="q-px-xl q-mr-sm"
            color="grey-7"
            name="cancel"
            @click="onCancelButtonClick"
          >
            {{ $gettext("BACK") }}
          </q-btn>
        </div>
      </q-footer>
    </q-layout>
  </q-dialog>
</template>

<script>
import { repository } from 'src/jtech/jtech-repository'
import { Component, Vue } from 'vue-property-decorator'
import GeneratorOrderPageSearchItemsDetail from './GeneratorOrderPageSearchItemsDetail.vue'
import { JtDynamicForm, JtCrud, JtDataTable } from 'jtech-webcomps'
const { page, pageTable, CrudLayoutSearch, form, input, compositions, composition } = JtCrud

@Component({
  name: 'GeneratorOrderPageSearchItemsModal',
  components: {
    GeneratorOrderPageSearchItemsDetail,
    JtDynamicForm,
    CrudLayoutSearch,
    page,
    pageTable,
    JtDataTable,
    'crud-form': form,
    'crud-input': input,
    compositions,
    composition
  }
})
export default class GeneratorOrderPageSearchItemsModal extends Vue {
  formDetail = null;
  totalOrder = '0,00';

  get inputsComposition () {
    return this.formDetail[0].inputs.filter(
      ci => ci.type === 'COMPOSICAO'
    )
  }

  onCancelButtonClick () {
    this.hide()
  }

  async loadDetail (params) {
    this.formDetail = await repository.resolve('controlBatchTicket.detalharControlBatch', params)
    if (this.formDetail[0] && this.formDetail[0].dadosForm) {
      this.totalOrder = Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(this.formDetail[0].dadosForm.totalOrder)
    } else {
      this.totalOrder = '0,00'
    }
  }

  hide () {
    this.$refs.generatorOrderPageSearchItemsModal.hide()
  }

  async show (params) {
    await this.loadDetail(params)
    this.$refs.generatorOrderPageSearchItemsModal.show()
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#GeneratorOrderPageSearchItemsModal {
  #subtitle {
    background-color: #eceff1;
    font-weight: 500;
    height: 45px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 10%;
  }
}
</style>
